import { ThemeProvider } from "@mui/material";
import CssBaseline from "@mui/material/CssBaseline";
import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import AppointmentScheduler from "./components/AppointmentScheduler";
import AdminDashboard from "./pages/AdminDashboard";
import { FeedbackPage } from "./pages/FeedbackPage";
import LoginPage from "./pages/LoginPage";
import ProtectedRoute from "./components/auth/ProtectedRoute";
import { AuthProvider } from "./hooks/useAuth";
import theme from "./theme";  // Import our new theme
// import './test-scheduling.js';

function App() {
  return (
    <React.StrictMode>
      <BrowserRouter>
        <AuthProvider>
          <ThemeProvider theme={theme}>
            <CssBaseline />
            <div
              style={{
                minHeight: "100vh",
                display: "flex",
                flexDirection: "column",
                backgroundColor: theme.palette.background.default,
              }}
            >
              <Routes>
                {/* Public routes */}
                <Route path="/" element={<AppointmentScheduler />} />
                <Route path="/feedback" element={<FeedbackPage />} />
                <Route path="/login" element={<LoginPage />} />
                
                {/* Protected admin routes */}
                <Route 
                  path="/admin/*" 
                  element={
                    <ProtectedRoute requiredRoles={['admin', 'super_admin']}>
                      <AdminDashboard />
                    </ProtectedRoute>
                  } 
                />
              </Routes>
            </div>
          </ThemeProvider>
        </AuthProvider>
      </BrowserRouter>
    </React.StrictMode>
  );
}

export default App;
